import styled from 'styled-components';

const Wrapper = styled.section`
	padding-top: var(--spacing-xx-large);
	.loadingstyle {
		height: calc(100vh - var(--px-250)) !important;
		
		& > section {
			flex-direction: column;
			justify-content: center;
			align-items: center;
			height: 100%;
			margin: 0 auto;
			display: flex;
		}
	}

	//pagination

	.pagerholder {
		width: calc(100vw - var(--px-80)) !important;
		margin: 0 auto;
		max-width: 2048px;
		display: flex;
		padding: var(--px-24) 0;

		.pagin-btn[disabled] {
			svg {
				fill: var(--neutrals-700);
			}
		}
	}

	.permissiongroup-paging {
		justify-content: flex-end;
		line-height: normal;
		min-width: auto !important;
		font-size: var(--px-14);
		background: var(--neutrals-00white);
		border-top: 1px solid var(--neutrals-200);
	}

	.mainwrapper {
		overflow: hidden;

		.toastMessage {
			.motif-toast-text-container {
			}

			&.block {
				display: block;
			}

			&.none {
				display: none;
			}
		}

		.message {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			height: calc(100vh - var(--px-194));

			&h5 {
				color: var(--neutrals-900);
			}
		}

		//heading

		.headerdetail {
			display: flex;
			padding-bottom: var(--spacing-x-large);
			.title {
				margin-right: auto;
			}

			.addmember .motif-button {
				&[disabled] {
					pointer-events: none;
				}
			}

			.addmember.button {
				display: flex;
				align-items: end;
			}
		}

		.permissiongroup {
			.pageheading {
				display: flex;
				padding: var(--px-20) 0;
				svg {
					min-width: var(--px-25) !important;
					min-height: var(--px-25) !important;
					margin-right: var(--px-10);
				}

				h3 {
					margin: 0;
					line-height: var(--px-25);
				}
			}
		}

		//addon

		.add-on {
			display: flex;
			margin-right: auto;
			padding: 0 0 var(--px-20) 0;

			.adduser {
				.motif-button {
					height: var(--px-40);
					width: var(--px-100);
				}
			}

			.search {
				width: 16%;
				margin-right: auto;
			}
		}

		.norecord {
			height: calc(100vh - var(--px-316));
			display: inline-block;
			width: 100%;
			display: flex;
			justify-content: center;
			flex: 0 auto;
			align-items: center;
			font-size: var(--px-16);
			color: var(--neutrals-700);
		}

		.managepermissionTable {
			height: 100%;
			overflow-y: auto;
			user-select: none;
			.errorRow {
				color: var(--red-600) !important;
			}
		}
	}
`;
export default Wrapper;
